// extracted by mini-css-extract-plugin
export default {"root":"WhiteBlock_root__DLqMb"};